module.exports = __webpack_public_path__ + "static/media/moneybird.ada8867c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/moneybird.webp
// module id = 333
// module chunks = 0